<template>
    <transition appear name="fade">
        <div class="d-flex flex-column">
            <div class="d-flex justify-content-between">
                <div id="space-filler"></div>
                <appAdminSidebar></appAdminSidebar>
                <appHeader />
            </div>

            <div class="container p-3">
                <input type="text" class="form-control mb-3" v-model="searchQuery"
                    placeholder="Search gift card by name..." />

                <div v-for="brand in filteredBrands" :key="brand.brandKey" class="mb-4 card p-3 shadow-sm">
                    <div class="d-flex justify-content-between align-items-center cursor-pointer"
                        @click="toggleSelectedBrand(brand.brandKey)">
                        <h5>{{ brand.brandName }}</h5>
                        <img :src="brand.imageUrls['130w-326ppi']" alt="brand" style="max-height: 40px" />
                    </div>

                    <div v-if="selectedBrandKey === brand.brandKey" class="mt-3">
                        <div class="row">
                            <div v-for="item in brand.items" :key="item.utid" class="col-md-4 col-sm-6 mb-3">
                                <div class="card h-100 shadow-sm">
                                    <div class="card-body">
                                        <h6 class="card-title mb-2">{{ item.rewardName }}</h6>
                                        <p class="mb-1">
                                            <strong>Type:</strong>
                                            {{ item.valueType.replace("_VALUE", "") }}
                                        </p>
                                        <p class="mb-1">
                                            <strong>Currency:</strong> {{ item.currencyCode }}
                                        </p>
                                        <p class="mb-1"><strong>UTID:</strong> {{ item.utid }}</p>
                                        <p class="mb-1"><strong>Brand Key:</strong> {{ brand.brandKey }}</p>
                                        <div v-if="item.valueType === 'FIXED_VALUE'">
                                            <span class="badge bg-success">Amount: ${{ item.faceValue.toFixed(2) }}</span>
                                        </div>
                                        <div v-else-if="item.valueType === 'VARIABLE_VALUE'">
                                            <span class="badge bg-warning text-dark">Range: ${{ item.minValue.toFixed(2) }}
                                                - ${{
                                                    item.maxValue.toFixed(2)
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <appFooter />
            </div>
        </div>
    </transition>
</template>
  
  
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar";
import GiftcardService from "../../services/GiftcardService";

export default {
    name: "GiftCardList",
    components: {
        appHeader: Header,
        appFooter: Footer,
        appAdminSidebar: AdminSidebar,
    },
    data() {
        return {
            searchQuery: "",
            selectedBrandKey: null,
            catalogData: {
                brands: [],
            },
        };
    },
    computed: {
        filteredBrands() {
            return this.catalogData.brands.filter((brand) =>
                brand.brandName.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    methods: {
        toggleSelectedBrand(brandKey) {
            this.selectedBrandKey =
                this.selectedBrandKey === brandKey ? null : brandKey;
        },
        async getGiftCardList() {
            try {
                const response = await GiftcardService.getGiftCardList();
                if (response.data.brands?.length > 0) {
                    this.catalogData = response.data;
                }
            } catch (e) {
                console.error("Error fetching gift cards:", e);
            }
        },
    },
    mounted() {
        this.getGiftCardList();
    },
};
</script>
  
<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.card-body {
    font-size: 0.9rem;
}
</style>
  